module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticker-band"
  }, [_c('div', {
    staticClass: "ticker-inner",
    style: ({
      '-webkit-animation': 'marquee ' + _vm.time + 's linear infinite',
      'animation': 'marquee ' + _vm.time + 's linear infinite'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.tickerContent)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ticker-inner-2",
    style: ({
      '-webkit-animation': 'marqueetwo ' + _vm.time + 's linear infinite',
      'animation': 'marqueetwo ' + _vm.time + 's linear infinite'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.tickerContent)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0836b7b5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextTicker.vue
// module id = 137
// module chunks = 2